// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const QuickOrder: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-801.000000, -355.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(722.000000, 125.000000)" id="UI-Icon/quick-order">
                    <path d="M2.28571429,0 L21.7142857,0 C22.9766509,0 24,1.02334914 24,2.28571429 L24,21.7142857 C24,22.9766509 22.9766509,24 21.7142857,24 L2.28571429,24 C1.02334914,24 0,22.9766509 0,21.7142857 L0,2.28571429 C0,1.02334914 1.02334914,0 2.28571429,0 Z M2.28571429,1.71428571 C1.970123,1.71428571 1.71428571,1.970123 1.71428571,2.28571429 L1.71428571,21.7142857 C1.71428571,22.029877 1.970123,22.2857143 2.28571429,22.2857143 L21.7142857,22.2857143 C22.029877,22.2857143 22.2857143,22.029877 22.2857143,21.7142857 L22.2857143,2.28571429 C22.2857143,1.970123 22.029877,1.71428571 21.7142857,1.71428571 L2.28571429,1.71428571 Z"></path>
                    <path d="M17.3780171,7.18723241 C18.2960171,6.26591898 19.7205245,7.6908742 18.8027932,8.61200853 L18.8027932,8.61200853 L11.0653902,16.37771 C11.0053341,16.4379947 10.943109,16.4882349 10.8795128,16.529229 C10.5320298,16.9332422 9.90328046,17.1037154 9.41547974,16.6184264 C8.29401706,15.5027846 7.17246482,14.3870533 6.05100213,13.2714115 C5.12897228,12.3541279 6.55392751,10.9296205 7.47577825,11.8466354 C8.59724094,12.9622772 9.71879318,14.0780085 10.8402559,15.1936503 L10.1168494,14.4749623 C12.5372188,12.0457683 14.9576574,9.61650038 17.3780171,7.18723241 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(QuickOrder);
